export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-road-map-line',
      title: '土木工事',
      description: '道路工事、造成工事、擁壁工事など、あらゆる土木工事に対応。確かな技術力で安全・確実な施工を行います。',
      image: 'https://public.readdy.ai/ai/img_res/bdf0b4e74c6102524f6524a51a569abc.jpg'
    },
    {
      icon: 'ri-drop-line',
      title: '水道工事',
      description: '上下水道の新設・修繕・メンテナンスまで幅広く対応。地域のライフラインを支える重要な工事です。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20plumbers%20and%20water%20pipe%20installation%20workers%20in%20Okayama%2C%20professional%20water%20infrastructure%20construction%2C%20modern%20pipe%20laying%20equipment%2C%20safety%20gear%2C%20clean%20construction%20environment%2C%20bright%20daylight%2C%20high%20quality%20plumbing%20work&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-roadster-line',
      title: '舗装工事',
      description: 'アスファルト舗装、コンクリート舗装など、道路舗装工事全般に対応。美しく耐久性の高い仕上がりを実現します。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20road%20paving%20workers%20in%20Okayama%2C%20asphalt%20and%20concrete%20road%20construction%2C%20professional%20paving%20equipment%20and%20machinery%2C%20workers%20in%20safety%20gear%2C%20smooth%20road%20surface%20construction%2C%20bright%20sunny%20day%2C%20high%20quality%20road%20work&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-home-4-line',
      title: '外構工事',
      description: '住宅や商業施設の外構工事、駐車場整備、フェンス設置など、建物周りの環境整備を行います。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20building%20exterior%20landscaping%20and%20parking%20areas%20in%20Okayama%2C%20residential%20and%20commercial%20exterior%20construction%2C%20fence%20installation%2C%20professional%20outdoor%20construction%20work%2C%20clean%20organized%20site%2C%20bright%20daylight&width=400&height=300&seq=service4&orientation=landscape'
    },
    {
      icon: 'ri-landscape-line',
      title: '造成工事',
      description: '宅地造成、工業団地造成など、土地の有効活用のための造成工事を安全・確実に施工いたします。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20land%20development%20and%20site%20preparation%20workers%20in%20Okayama%2C%20residential%20and%20industrial%20land%20grading%20construction%2C%20heavy%20earthmoving%20equipment%2C%20professional%20site%20development%2C%20safety%20protocols%2C%20bright%20sunny%20environment&width=400&height=300&seq=service5&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'メンテナンス',
      description: '完成後のアフターサービスも充実。定期点検や修繕工事まで、長期的なサポートを提供します。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20maintenance%20workers%20performing%20infrastructure%20inspection%20and%20repair%20in%20Okayama%2C%20professional%20maintenance%20team%20with%20tools%20and%20equipment%2C%20quality%20control%20and%20safety%20inspection%2C%20clean%20work%20environment%2C%20bright%20daylight&width=400&height=300&seq=service6&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>事業内容</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            岡山市・倉敷市を中心とした岡山県内で、土木工事から水道工事、舗装工事まで幅広く対応。
            地域密着で20年以上の実績を持つ確かな技術力でお応えします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/services"
            className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            事業内容の詳細を見る
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}